<template>
	<div class="center-container">
		<h1>Page not found</h1>
		<p>Sorry, but the page you are looking for does not exist. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
		<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
</template>
<script>
export default 
{
	created () 
	{
		document.title = "Page not found | Bookplate";
	}
}
</script>